import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import CalendarSchedulerPure from 'components/widgets/CalendarScheduler'
import WelcomeHeader from 'components/branding/WelcomeHeader'
import scribbleIcon from '@assets/images/v2-dashboard/Scribble-icon.png'
import ScheduleKickOffCallLeft from './leftSide'

const ScheduleKickOffCall = () => {
  const apps = useSelector(state => state.apps)
  const { search } = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    window.addEventListener('message', function fn(data) {
      if (data.data.meetingBookSucceeded) {
        if (apps.firstAppID) {
          history.push(`/app/${apps.firstAppID}/overview`)
        } else {
          history.push('/apps')
        }
      }
    })
  }, [search, apps, history, dispatch])

  return (
    <>
      <WelcomeHeader step={6} totalSteps={6} />

      <div style={{ display: 'flex', gap: '90px', justifyContent: 'center' }}>
        <div style={{ paddingTop: '80px' }}>
          <ScheduleKickOffCallLeft
            appID={
              apps.firstAppID !== undefined && apps.firstAppID !== '' && apps.firstAppID
                ? apps.firstAppID
                : false
            }
          />
        </div>
        <div style={{ paddingTop: '30px' }}>
          <CalendarSchedulerPure />
          <div style={{ marginBottom: '50%', top: '25%', position: 'absolute', left: '43%' }}>
            <img
              src={scribbleIcon}
              alt="Scribble Icon"
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ScheduleKickOffCall
